import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle scroll + resize
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    const handleResize = () => setIsMobile(window.innerWidth < 768);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Prevent background scroll when menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const linkStyle = {
    color: "white",
    textDecoration: "none",
    cursor: "pointer",
    transition: "color 0.3s ease",
  };

  const handleHover = (e, color) => {
    if (!isMobile) {
      e.target.style.color = color;
    }
  };

  return (
    <div
      style={{
        background: scrolled ? "rgba(0,0,0,0.7)" : "#000",
        backdropFilter: scrolled ? "blur(8px)" : "none",
        color: "white",
        padding: "15px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        minHeight: "60px",
      }}
    >
      {/* LOGO */}
      <h2
        style={{
          color: "#FFC107",
          fontSize: isMobile ? "18px" : "22px",
          margin: 0,
          whiteSpace: "nowrap",
        }}
      >
        G Bond
      </h2>

      {/* DESKTOP MENU */}
      {!isMobile && (
        <div style={{ display: "flex", gap: "25px", alignItems: "center" }}>
          <Link
            to="/"
            style={linkStyle}
            onMouseEnter={(e) => handleHover(e, "#FFC107")}
            onMouseLeave={(e) => handleHover(e, "white")}
          >
            Home
          </Link>

          <Link
            to="/products"
            style={linkStyle}
            onMouseEnter={(e) => handleHover(e, "#FFC107")}
            onMouseLeave={(e) => handleHover(e, "white")}
          >
            Products
          </Link>

          <Link
            to="/about"
            style={linkStyle}
            onMouseEnter={(e) => handleHover(e, "#FFC107")}
            onMouseLeave={(e) => handleHover(e, "white")}
          >
            About
          </Link>

          <Link
            to="/contact"
            style={linkStyle}
            onMouseEnter={(e) => handleHover(e, "#FFC107")}
            onMouseLeave={(e) => handleHover(e, "white")}
          >
            Contact
          </Link>

          <a
            href="https://wa.me/917412885533"
            target="_blank"
            rel="noreferrer"
          >
            <button style={waBtn}>WhatsApp</button>
          </a>
        </div>
      )}

      {/* MOBILE MENU ICON */}
      {isMobile && (
        <div
          onClick={() => setMenuOpen(!menuOpen)}
          style={{ fontSize: "22px", cursor: "pointer" }}
        >
          {menuOpen ? "✕" : "☰"}
        </div>
      )}

      {/* MOBILE DROPDOWN */}
      {isMobile && menuOpen && (
        <div
          style={{
            position: "absolute",
            top: "60px",
            left: 0,
            width: "100%",
            background: "#000",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            boxShadow: "0 10px 20px rgba(0,0,0,0.5)",
          }}
        >
          <Link
            to="/"
            style={linkStyle}
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>

          <Link
            to="/products"
            style={linkStyle}
            onClick={() => setMenuOpen(false)}
          >
            Products
          </Link>

          <Link
            to="/about"
            style={linkStyle}
            onClick={() => setMenuOpen(false)}
          >
            About
          </Link>

          <Link
            to="/contact"
            style={linkStyle}
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </Link>

          <a
            href="https://wa.me/917412885533"
            target="_blank"
            rel="noreferrer"
          >
            <button style={waBtn}>WhatsApp</button>
          </a>
        </div>
      )}
    </div>
  );
}

const waBtn = {
  background: "#25D366",
  border: "none",
  padding: "8px 15px",
  color: "white",
  borderRadius: "5px",
  cursor: "pointer",
};

export default Navbar;